import { Component, input } from '@angular/core';

export type IconName =
  | 'crown'
  | 'plane'
  | 'hotel'
  | 'car'
  | 'palm'
  | 'chat'
  | 'list'
  | 'case'
  | 'arrow';

/**
 * Thin wrapper around the <use> reference into public/assets/icons.svg,
 * mirroring the original site's inline SVG symbol-sprite approach.
 */
@Component({
  selector: 'demo-icon',
  standalone: true,
  template: `
    <svg [attr.width]="size()" [attr.height]="size()" aria-hidden="true" focusable="false">
      <use [attr.href]="'assets/icons.svg#i-' + name()"></use>
    </svg>
  `,
  host: { class: 'demo-icon' },
})
export class IconComponent {
  readonly name = input.required<IconName>();
  readonly size = input<number>(24);
}
